import {
    getGetTestingControlsTestingControlIdQueryKey,
    useGetTestingControlsTestingControlIdSuspense,
} from "../../../../../api/generated/testing-controls/testing-controls";

export const getTestingControlQueryKey =
    getGetTestingControlsTestingControlIdQueryKey;

export function useTestingControlQuery(testingControlId: string) {
    return useGetTestingControlsTestingControlIdSuspense(testingControlId, {
        query: { select: (response) => response.data },
    });
}
